import LoginLayout from '@/components/layouts/LoginLayout'
import { Form, Head } from '@inertiajs/react'
import { Input, Button } from 'antd'
import { useState } from 'react'

interface OtpRequestProps {
  csrf_token: string
}

export default function OtpRequest({ csrf_token }: OtpRequestProps) {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  return (
    <LoginLayout title="Request a Login OTP">
      <Head title="Login" />
      <div className="w-[500px] bg-white shadow-md p-14">
        <div className="w-[388px] mx-auto">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4 text-center">
            Login with OTP
          </h2>
          <p className="text-sm text-gray-600 text-center mb-6">
            Enter the email linked to your account.<br />We will send a 6-digit code for password-free sign in.
          </p>
          <Form
            action="/login/otp"
            method="post"
            onSubmit={() => setLoading(true)}
            onSuccess={() => setLoading(false)}
            onError={() => setLoading(false)}
          >
            <input type="hidden" name="authenticity_token" value={csrf_token} />
            <div className="">
              <label htmlFor="otp-email" className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <Input
                id="otp-email"
                name="otp[email]"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                className="ant-input w-full"
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="mt-4">
              <Button
                type="primary"
                htmlType="submit"
                className="w-full text-white border-none rounded font-medium cursor-pointer mt-2 block"
                loading={loading}
              >
                Send OTP
              </Button>
            </div>
          </Form>
          <div className="mt-4 text-center">
            <a className="text-blue-500 text-sm" href="/login">
              Back to password login
            </a>
          </div>
        </div>
      </div>
    </LoginLayout>
  )
}
